import "./Emphasis.scss";
const Emphasis = (props) => {
  return <span className="type--emphasis">{props.children}</span>;
};

export default Emphasis;
